<template>
  <div :class="[`x3-2`, className || ``]">
    <icon :className="iconProps.className" :bgProps="iconProps.bgProps" />
    <div class="text-12">
      <div class="instant-features-10 inter-bold-link-water-24px">
        <span class="span-11 inter-bold-link-water-24px">Reklamator </span
        ><span class="span-11 inter-medium-link-water-24px-2">garancije</span>
      </div>
      <p class="duis-aute-irure-dolo-11 inter-normal-gull-gray-18px">
        sistem digitalnog upravljanja <br />garancijama i reklamacijama<br />automatizovan postupak <br />prijema i
        odgovora
      </p>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";
export default {
  name: "X3",
  components: {
    Icon,
  },
  props: ["className", "iconProps"],
};
</script>

<style>
.x3-2 {
  height: 230px;
  margin-right: -145px;
  min-width: 325px;
  position: relative;
}

.text-12 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 150px;
  left: 0;
  position: absolute;
  top: 80px;
  width: 325px;
}

.instant-features-10 {
  letter-spacing: -0.25px;
  line-height: 34px;
  margin-left: 1px;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: 252px;
}

.duis-aute-irure-dolo-11 {
  letter-spacing: -0.25px;
  line-height: 27px;
  min-height: 108px;
  text-align: center;
  width: 325px;
}

.x3-2.x3-3 {
  margin-right: unset;
}
</style>
